const baseUrl = '/xapi/Voip/Lcr';
const baseUrl2 = '/xapi/VoipMrt/Lcr';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {},
    actions: {
        async listForRootAsUser(context, params) {
            let baseToUse = baseUrl
            if ($store.getters['user-state/isUserMrt']) {
                baseToUse = baseUrl2
            }

            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search')) ? "&search=" + encodeURIComponent(params.search) : ''
            let division = '&division_id=' + params['division_id']
            let requested_user_id = '&requested_user_id=' + params['requested_user_id']
            let requested_user_profile = '&requested_user_profile=' + params['requested_user_profile']
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseToUse + '/listForRootAsUser/1?page=' + page + division + search + requested_user_id + requested_user_profile,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },async listTopDestinations(context, params) {
            let baseToUse = baseUrl
            if ($store.getters['user-state/isUserMrt']) {
                baseToUse = baseUrl2
            }

            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search')) ? "&search=" + encodeURIComponent(params.search) : ''
            let division = '&division_id=' + params['division_id']
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseToUse + '/listTopDestinations?page=' + page + division + search,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
    }

};

export default api
